import type { Element } from "React";
import { FormattedMessage } from "react-intl";
type Props = {
  className?: string;
};

const IconIceHockey = (props: Props): Element<"svg"> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 32 32"
    className={props.className}
  >
    <title id="title">
      <FormattedMessage tagName="span" id="sport-ice-hockey" />
    </title>
    <path d="M31.1 20.5c0.5 1.4-0.6 3.1-2.8 4.6-1.8 1.3-4.5 2.6-7.6 3.6-3.1 1-6 1.6-8.2 1.6-2.7 0.1-4.5-0.6-5-2l-1.7-5.2c-0.3-0.6-0.3-1.4 0-2.1 0.4-1 1.3-2 2.7-2.9 1.8-1.3 4.5-2.6 7.6-3.6 3.1-1 6-1.6 8.2-1.6 1.6 0 3 0.2 3.9 0.7 1.4 0.8 1.9 3.6 2.4 5.1 0.6 1.7 0.2 0.5 0.6 1.8v0zM10.4 13.2c-1.1-2.5-2.4-4.5-4.1-6.7-0.8-1.1-1.7-2.1-2.6-3 5.2 1.1 9.1 2.9 13.1 7.6 0.3-0.1 0.6-0.1 1-0.1l1.5-0.2-1-1.1c-4.7-5-10.1-7.1-16.8-8.1l-0.6 1.3c1.5 1.3 2.9 2.8 4.3 4.6 1.3 1.8 2.6 3.7 3.8 5.8l0.4 0.7 0.7-0.5c0.2-0.1 0.3-0.2 0.5-0.3v0zM20.6 22.5l1.1 3.4c0.9-0.3 1.7-0.7 2.4-1.1l-1.1-3.4c-0.8 0.4-1.6 0.7-2.4 1v0zM21 26.2l-1.1-3.4c-0.3 0.1-0.7 0.2-1 0.3-3.1 1-6 1.6-8.2 1.6-0.7 0-1.4 0-1.9-0.1l1 2.9c0.1 0.4 1.2 0.5 2.8 0.5 2-0.1 4.7-0.6 7.6-1.5 0.3-0.1 0.7-0.2 1-0.3v0zM23.7 21.1l1.1 3.4c0.4-0.2 0.7-0.4 1.1-0.6l-1.1-3.3c-0.3 0.2-0.7 0.4-1.1 0.6v0zM25.4 20.2l1.1 3.3c0.2-0.1 0.3-0.2 0.4-0.3 0.2-0.1 0.3-0.2 0.5-0.4l-1.1-3.3c-0.3 0.2-0.6 0.4-0.9 0.6v0zM27.3 18.8l1.1 3.2c0.4-0.4 0.6-0.7 0.5-0.9-0.8-2.5-0.4-1.3-0.6-1.8l-0.4-1.1c-0.2 0.2-0.4 0.4-0.6 0.6v0zM24.3 15.2c-2 0.1-4.7 0.6-7.6 1.5-2.9 0.9-5.3 2.1-7 3.3-1.3 0.9-2.1 1.7-2 2s1.2 0.5 2.8 0.5c2-0.1 4.7-0.6 7.6-1.5 2.9-0.9 5.3-2.1 7-3.3 1.3-0.9 2.1-1.7 2-2-0.1-0.4-1.2-0.5-2.8-0.5z" />
  </svg>
);

export default IconIceHockey;
